import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { IProps, IStateProps, IDispatchProps } from './interfaces';
import { IAppState } from '../../../state/reducers';
import {
  loadNotifications, markNotificationRead,
} from '../../../state/notifications';
import Notification from './Notification/component';
import { NotificationsContainer } from './styles';

class Notifications extends PureComponent<IProps> {
  componentDidMount() {
    const { onLoadNotifications } = this.props;
    onLoadNotifications();
  }
  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<{}>): void {
    const { timeout, onLoadNotifications } = this.props;
    if (timeout !== prevProps.timeout) {
      onLoadNotifications();
    }
  }

  render() {
    const {
      product,
      sport,
      isLoaded,
      onMarkRead,
    } = this.props;
    if (isLoaded) {
      let { notifications } = this.props;
      notifications = notifications.filter(({ products, sports, read }) => !read && (!!product && products.length ? products.includes(product) : true) && (!!sport && sports.length ? sports.includes(sport) : true));
      return (
        <NotificationsContainer>
          {notifications.map((notification) => (
            <Notification
              key={notification._id}
              notification={notification}
              markRead={() => onMarkRead(notification._id)}
            />
          ))}
        </NotificationsContainer>
      );
    }
    return null;
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  product: state.product?.target,
  sport: state.exchange?.initExchange?.sport,
  isLoaded: state.notifications?.isLoaded ?? false,
  notifications: state.notifications?.notifications ?? [],
  timeout: state.exchange?.initExchange?.timeout,
});

const mapDispatchToProps: IDispatchProps = {
  onLoadNotifications: loadNotifications,
  onMarkRead: markNotificationRead,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Notifications);
